import ozToggle from '@/components/oz-toggle'

export default {
  name: 'oz-toggle-display-address-type',

  props: {
    displayAddressType: { type: String },
    isPill: { type: Boolean, default: false },
  },

  data () {
    return {
      initialValue: false,
    }
  },

  created () {
    this.initialValue = Boolean(this.displayAddressType)
  },

  watch: {
    displayAddressType () {
      this.initialValue = Boolean(this.displayAddressType)
    },
  },

  methods: {
    updateDisplayAddressType (value) {
      this.initialValue = value

      const displayAddressType = value ? 'ALL' : ''
      this.$emit('filters:update', { displayAddressType }, 'displayAddressType')
    },
  },

  components: {
    ozToggle,
  },
}
